import { useMemo } from 'react';
import { useGetSpinnerData } from '~/context/vdp/VehicleContext';
import { GalleryImage } from '~/contracts/vdp';
import {
  transformExteriorImages,
  transformFeatures,
  transformImperfections
} from '~/utilities/vdp/imagery';

export default function useGalleryImages(): GalleryImage[] {
  const {
    features: featuresRaw = [],
    imperfections: imperfectionsRaw = [],
    spins = []
  } = useGetSpinnerData();

  return useMemo<GalleryImage[]>(() => {
    const featureImages = transformFeatures(featuresRaw);
    const imperfectionImages = transformImperfections(imperfectionsRaw);
    const exteriorImages = transformExteriorImages(spins);

    return featureImages.concat(imperfectionImages).concat(exteriorImages);
  }, [featuresRaw, imperfectionsRaw, spins]);
}
